import styled, { css } from 'styled-components';
import { screen, gutter, container, borderRadius } from '../../../styles/variables';

const Container = styled.div`
  margin-right: auto;
  margin-left: auto;
  padding-left:  ${gutter.small};
  padding-right: ${gutter.small};
  
  &:before,
  &:after {
    content: " "; // 1
    display: table; // 2
  }
  &:after {
    clear: both;
  }

  @media (min-width: ${screen.sm.up}) {
    width: calc(${screen.sm.up} - ${gutter.default});
  }
  @media (min-width: ${screen.md.up}) {
    width: calc(${screen.md.up} - ${gutter.default});
  }
  @media (min-width: ${screen.lg.up}) {
    width: calc(${screen.lg.up} - ${gutter.default});
  }
  @media (min-width: ${screen.xl.up}) {
    width: calc(${screen.xl.up} - ${gutter.default});
  }
`;

const PageWrapper = styled(Container)`
  padding-left: 0;
  padding-right: 0;
  max-width: ${container.default};
  background: #fff;
  
  @media(max-width: ${screen.sm.max}){
    margin-bottom: 0;
    margin-top: 0;
    border-radius: 0;
  }

  ${props => props.form && css`
    margin-top: ${gutter.large};
    margin-bottom: ${gutter.large};
    border-radius: ${borderRadius.large};

    box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.11);
    -webkit-box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.11);
    -moz-box-shadow: 0px 0px 10px 5px rgba(0,0,0,0.11);

    @media(max-width: ${screen.sm.max}){
      box-shadow: none;
    }
  `}

`;

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -${gutter.small};
  margin-right: -${gutter.small};
  ${props => props.mobileVertical && css`
    @media (max-width: ${screen.xs.max}) {
      flex-direction: column;
    }
  `}
`;

const columns = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const Col = styled.div`
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
  padding-left: ${gutter.small};
  padding-right: ${gutter.small};

  ${columns.map(column => props => props.xs === `${column}` && css`
    flex: 0 0 ${(100 / 12) * column}%;
    max-width: ${(100 / 12) * column}%;
  `)}

  @media (min-width: ${screen.sm.up}) {
    ${columns.map(column => props => props.sm === `${column}` && css`
      flex: 0 0 ${(100 / 12) * column}%;
      max-width: ${(100 / 12) * column}%;
    `)}
  }

  @media (min-width: ${screen.md.up}) {
    ${columns.map(column => props => props.md === `${column}` && css`
      flex: 0 0 ${(100 / 12) * column}%;
      max-width: ${(100 / 12) * column}%;
    `)}
  }
  
  @media (min-width: ${screen.lg.up}) {
    ${columns.map(column => props => props.lg === `${column}` && css`
      flex: 0 0 ${(100 / 12) * column}%;
      max-width: ${(100 / 12) * column}%;
    `)}
  }
`;

export {
  Container,
  Row,
  Col,
  PageWrapper
};
